import React from 'react';

import { VimeoPlugin } from '../../../types/Vimeo';

type Props = {
  video: VimeoPlugin;
};
const Vimeo: React.FC<Props> = ({ video }) => {
  const videoUrl = `https://player.vimeo.com/video/${video.vimeo_oembed.response.video_id}?byline=0`;
  return (
    <div
      style={{
        padding: '56.25% 0 0 0',
        position: 'relative',
      }}
    >
      <iframe
        allow="autoplay; fullscreen; picture-in-picture"
        src={videoUrl}
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
        }}
      />
    </div>
  );
};

export default Vimeo;
